/**
 * Client-offer workflow for requests & contact inbox.
 * Legacy values (pending, in_progress, done, …) map into these four stages.
 */

export const ADMIN_TASK_STATUS_OPTIONS = [
  {
    value: "new",
    label: "New",
    hint: "Not handled yet.",
    short: "Inbox",
  },
  {
    value: "waiting_response",
    label: "Waiting response",
    hint: "Offer sent — waiting for the client to approve or reject.",
    short: "Awaiting client",
  },
  {
    value: "confirmed",
    label: "Confirmed",
    hint: "Client approved — proceed with the engagement.",
    short: "Approved",
  },
  {
    value: "rejected",
    label: "Rejected",
    hint: "Client declined the offer.",
    short: "Declined",
  },
];

const ALLOWED = new Set(ADMIN_TASK_STATUS_OPTIONS.map((o) => o.value));

/** Map stored / legacy status strings to one of the four canonical values. */
export function canonicalAdminStatus(raw) {
  const s = String(raw || "").toLowerCase();
  const legacy = {
    pending: "new",
    new: "new",
    analysing: "waiting_response",
    in_progress: "waiting_response",
    waiting_response: "waiting_response",
    waiting: "waiting_response",
    done: "confirmed",
    confirmed: "confirmed",
    rejected: "rejected",
  };
  if (legacy[s]) return legacy[s];
  if (ALLOWED.has(s)) return s;
  return "new";
}

export function adminStatusLabel(status) {
  const c = canonicalAdminStatus(status);
  const opt = ADMIN_TASK_STATUS_OPTIONS.find((o) => o.value === c);
  return opt ? opt.label : "New";
}

export function adminStatusHint(status) {
  const c = canonicalAdminStatus(status);
  const opt = ADMIN_TASK_STATUS_OPTIONS.find((o) => o.value === c);
  return opt ? opt.hint : "";
}

/** Maps workflow status to a stable CSS modifier (see `.admin-dash__badge-stage--*`). */
export function adminStatusBadgeClass(status) {
  const c = canonicalAdminStatus(status);
  const slug = c.replace(/_/g, "-");
  return `admin-dash__badge-status admin-dash__badge-stage admin-dash__badge-stage--${slug}`;
}
